import {
  AfterViewInit,
  Component,
  ElementRef, HostListener, Inject,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {DxFormComponent} from 'devextreme-angular';
import {BehaviorSubject, Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {LoginViewModel} from 'src/app/shared/models/general';
import {LogIn} from 'src/app/stores/actions/fusion-auth.actions';
import {AppState, selectAuthState} from 'src/app/stores/app.state';
import {FusionAuthService} from '../../../shared/services/fusion-auth';
import {AppInfoService} from '../../../shared/services/general';
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild(DxFormComponent, {static: true}) public form?: DxFormComponent;
  public formData: LoginViewModel = new LoginViewModel();
  public capsOn: any;
  public errorMessage: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private onDestroy$ = new Subject();

  constructor(
    private render: Renderer2,
    private router: Router,
    private fusionAuth: FusionAuthService,
    private store: Store<AppState>,
    private elRef: ElementRef,
    public applicationInfo: AppInfoService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {
    this.formSubmitted = this.formSubmitted.bind(this);
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
      this.renderCapsLockMessage();
  }

  public changeCapsOn(value: any) {
    this.capsOn = value;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.capsOn && changes.capsOn.currentValue !== undefined) {
      console.log(changes.capsOn.currentValue);
    }
  }

  public ngAfterViewInit(): void {
    this.fusionAuth.cleanCredentials();
  }

  public async ngOnInit(): Promise<void> {
    if (this.fusionAuth.IsLoggedIn === 'true') {
      await this.router.navigateByUrl('/secured/results/lab');
      return;
    }
  }

  private renderCapsLockMessage() {
    const parent = this.elRef.nativeElement.querySelector('.dx-validationsummary') as HTMLElement;

    if (!parent) return;

    for (let i = 0; i < (parent.children as HTMLCollection).length; i++) {
      if (parent.children.item(i) && typeof parent.children.item(i)?.remove === 'function') {
        parent.children.item(i)?.remove();
      }
    }

    if (this.capsOn) {
      const errorMessage = `
                <div id="caps-lock-alert" class="dx-item dx-validationsummary-item">
                  <div class="dx-item-content dx-validationsummary-item-content">
                    Caps-lock is on
                    </div>
                    </div>
              `;
      if (parent) {
        parent.insertAdjacentHTML('beforeend', errorMessage);
      }
    } else {
      const element = this.document.getElementById('caps-lock-alert');
      if (element && parent)
        this.renderer.removeChild(parent, element);
    }
  }

  private renderResponseErrorMessage(message: string) {
    const parent = this.elRef.nativeElement.querySelector('.dx-validationsummary') as HTMLElement;

    if (!parent) return;

    for (let i = 0; i < (parent.children as HTMLCollection).length; i++) {
      if (parent.children.item(i) && typeof parent.children.item(i)?.remove === 'function') {
        parent.children.item(i)?.remove();
      }
    }

    if (message === null) {
      const errorElement = this.elRef.nativeElement.querySelector('#custom-error');
      if (errorElement) {
        this.render.removeChild(parent, errorElement);
      }
    } else {
      const errorMessage = `
                <div class="dx-item dx-validationsummary-item">
                  <div class="dx-item-content dx-validationsummary-item-content">
                    ${message}
                    </div>
                    </div>
              `;
      if (parent) {
        parent.insertAdjacentHTML('beforeend', errorMessage);
      }
    }
  }

  public async formSubmitted() {
    this.store.dispatch(new LogIn({loginId: this.formData.loginId, password: this.formData.password, applicationId: this.formData.applicationId} as any));
    this.store.select(selectAuthState).pipe(takeUntil(this.onDestroy$)).subscribe((state: any) => {
      this.errorMessage.next(state.errorMessage);
      this.isLoading.next(state.isLoading);
      this.renderResponseErrorMessage(state.errorMessage);
    });
  }

  public get IsLoading() {
    return this.isLoading.value;
  }

  public set IsLoading(value: boolean) {
    this.isLoading.next(value);
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
